import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { selectEvent } from "../../../../redux/preferences/selectors";
import { connect } from "react-redux";
import ExportCard from "./ExportCard";
import axios from "../../../../services/api";

class _Exports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: []
    };
  }

  static propTypes = {
    event: PropTypes.object
  };

  componentDidMount() {
    this.fetchReports();
    this.interval = setInterval(() => this.fetchReports(), 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchReports() {
    axios.get(`/events/${this.props.event.id}/reporting`).then(data => {
      this.setState({
        reports: data.data.data
      });
    });
  }


  render() {
    const { reports } = this.state;
    return [
      <AdminSubHeader title="Exports" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-line-graph" />
                    </span>
                    <h3 className="m-portlet__head-text">Excel Exports</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                {reports.map(report => (
                  <ExportCard report={report} key={report.name} eventId={this.props.event.id} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function(state) {
  return {
    event: selectEvent(state)
  };
};

const Exports = connect(mapStateToProps, mapDispatchToProps)(_Exports);

export default Exports;
